import { NgClass } from "@angular/common";
import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Inject,
  Output,
  signal,
  ViewChild,
} from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { MatButton } from "@angular/material/button";
import { MatDialogActions } from "@angular/material/dialog";
import { Data } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule, MenuController } from "@ionic/angular";
import { TranslateService } from "@ngx-translate/core";
import { getFunctions, httpsCallable } from "firebase/functions";
import { from } from "rxjs";
import { SafeHtmlPipe } from "../../pipe/safehtmlpipe";
@Component({
  selector: "app-spell-of-fortune",
  templateUrl: "./spell-of-fortune.component.html",
  styleUrls: ["./spell-of-fortune.component.scss"],
  standalone: true,
  imports: [
    MatButton,
    NgClass,
    IonicModule,
  ],
})
export class SpellFortuneComponent implements AfterViewInit {
  @ViewChild("dynamicContent") dynamicContent: ElementRef;
  @Output() InboxDelete = new EventEmitter();
  selectedLanguage: string = "en";
  referral_code: string = "";
  referralUrl: string = "";
  dynamicScriptsExecuted: boolean;
  public data: Data;
  public mustWinTemplate = false;
  public inboxChurnRisk = false;
  public newSjPrizeStatus = false;
  public defaultLanguage: string;
  public checkListMsg = false;
  selectedLanguageSignal = signal<string>("")
  preferredCurrencySignal = signal<string>("")
  logoClasses = ['logo-st', 'logo-nd', 'logo-rd', 'logo-th'];
  userId: string;
  constructor(
    private sheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public inboxData: any,
    private matBottomSheet: MatBottomSheetRef<SpellFortuneComponent>,
    private menu: MenuController,
    public translate: TranslateService,
    public authService: AuthService
  ) { }

  async ngOnInit() {
    await this.authService.getUid("GamesFeedSampleComponent").then((uid) => {
      this.userId = uid;
    })
  }

  async close() {
    await this.sheet.dismiss();
    await this.menu.open("inboxMenu").catch((err) => { });
  }

  ngAfterViewInit() {
    //empty
  }

  async closeDialog() {
    await this.matBottomSheet.dismiss();
    await this.close();
  }

  getCurrentPromoDetails(promo: Data) {
    if (promo.status) return;
    const request = {
      game_price: this.inboxData.game_price || 0,
      user_id: this.userId,
      promo_name: promo.promo_name,
    };
    const functions = getFunctions();
    functions.region = AuthService.FIREBASE_REGION;
    const promoFunction = httpsCallable(functions, "lowpointsonpremiumgame");
    return from(promoFunction(request)).pipe().subscribe({
      next: (result) => {
        if (result.data) {
          this.closeDialog();
        }
      },
      error: (error) => {
        console.error("Error calling promo function:", error);
        this.closeDialog();
      },
    });
  }

  getLogoClass(index: number): string {
    return this.logoClasses[index] || 'logo-nd'; // fallback if more items
  }
}
